<template>
  <div>
    <table-layout
      pkField="server_id"
      :selected.sync="selected"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :items="servers"
      :columns="columns"
    >
      <template #actions>
        <b-dropdown-item @click="runServers" aria-role="listitem">{{ $t('server.actions.run') }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogStop" aria-role="listitem">{{ $t('server.actions.stop') }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{
          $t('server.actions.delete')
        }}</b-dropdown-item>
      </template>

      <template #status="props">
        <status-indicator :status="props.value.status"></status-indicator>
      </template>

      <template v-if="isAdmin" #runstop="props">
        <div class="buttons">
          <button
            :disabled="
              props.value.status === 'processing' ||
                props.value.status !== 'STANDBY' ||
                props.value.status === 'OFFLINE'
            "
            @click="runServers(props.value.server_id)"
            class="button is-success play"
          >
            <span class="icon is-small">
              <i class="fas fa-play"></i>
            </span>
          </button>
          <button
            :disabled="
              props.value.status === 'processing' ||
                props.value.status === 'STANDBY' ||
                props.value.status === 'OFFLINE'
            "
            @click="openDialogStop(props.value.server_id)"
            class="button is-danger stop"
          >
            <span class="icon is-small">
              <i class="fas fa-stop"></i>
            </span>
          </button>
          <button
            :disabled="props.value.status === 'processing' || props.value.status === 'OFFLINE'"
            @click="openDialogRestart(props.value.server_id)"
            class="button reload"
          >
            <span class="icon is-small">
              <i class="fas fa-redo"></i>
            </span>
          </button>
        </div>
      </template>
    </table-layout>
  </div>
</template>

<script>
import TableLayout from '@/layout/TableLayout'
import StatusIndicator from '@/components/StatusIndicator'

import { createNamespacedHelpers } from 'vuex'
const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Servers',
  components: {
    TableLayout,
    StatusIndicator
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  mounted() {
    this.getServers()
  },
  data() {
    return {
      columns: [
        {
          field: 'name',
          label: 'server.table.name',
          sortable: true,
          route: {
            name: 'server',
            params: [
              {
                name: 'server_id',
                field: 'server_id'
              }
            ]
          }
        },
        {
          field: 'server_type',
          label: 'server.table.server_type',
          sortable: true
        },
        {
          field: 'inputs_models',
          label: 'server.table.inputs'
        },
        {
          slot: 'status',
          label: 'server.table.status',
          sortable: true
        },
        {
          field: 'ip_addresses',
          label: 'server.table.host',
          sortable: true
        },
        {
          field: 'server_id',
          label: 'server.table.server_id',
          bindHtml: true
        },
        {
          slot: 'runstop',
          label: 'server.table.start',
          class: 'runstop'
        }
      ],
      servers: [],
      selected: [],
      serversLoading: false
    }
  },
  methods: {
    addServer() {
      this.$router.push({
        name: 'add_server'
      })
    },
    refetchStatus() {
      const servers = this.servers.map(d => {
        return d['server_id']
      })
      const body = {
        server_ids: servers
      }
      const searchParams = new URLSearchParams(body)
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/servers/status?${searchParams}`
      fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.servers = this.servers.map(d => {
            if (servers.includes(d['server_id'])) {
              let server_data = data.filter(value => {
                return d['server_id'] == value.server_id
              })
              if (server_data.length) {
                d.status = server_data[0].status
                d.inputs_models = server_data[0].inputs_models
              }
            }
            return d
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
      if (this.$route.name == 'servers') {
        setTimeout(this.refetchStatus, 5000)
      }
    },
    getServers() {
      if (!this.serversLoading) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/servers`
        this.serversLoading = true
        fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.servers = data
            this.refetchStatus()
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const servers = this.servers
        .filter(value => {
          return indexSet.has(value.server_id)
        })
        .map(d => {
          return d['name']
        })
      const msg = servers
        .map(d => {
          return d
        })
        .join(', ')
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.servers = this.servers.map(value => {
            if (indexSet.has(value.server_id)) {
              value.status = 'processing'
            }
            return value
          })
          this.removeServers(this.selected)
            .then(res => {
              if (!res.ok) {
                throw res.json()
              }
              return res.json()
            })
            .then(() => {
              this.notifyServer({
                name: msg,
                status: 'deleted'
              })
            })
            .catch(error =>
              error.then(data => {
                this.$notify({
                  message: JSON.parse(data.message).message,
                  type: 'danger'
                })
              })
            )
            .finally(() => {
              this.serversLoading = false
            })
        }
      })
    },
    openDialogStop(server_id = undefined) {
      if (!this.selected.length && server_id === undefined) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }

      let server_ids = []
      if (server_id !== undefined) {
        server_ids.push(server_id)
      } else {
        server_ids = this.selected
      }
      let indexSet = new Set(server_ids)

      const servers = this.servers
        .filter(value => {
          return indexSet.has(value.server_id)
        })
        .map(d => {
          return d['name']
        })
      const msg = servers
        .map(d => {
          return d
        })
        .join(', ')
      this.$dialog.confirm({
        message: `${this.$t('confirm.stop', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.servers = this.servers.map(value => {
            if (indexSet.has(value.server_id)) {
              value.status = 'processing'
            }
            return value
          })
          this.stopServers(server_ids)
            .then(res => {
              if (!res.ok) {
                throw res.json()
              }
              return res.json()
            })
            .then(() => {
              this.notifyServer({
                name: msg,
                status: 'stopped'
              })
            })
            .catch(error =>
              error.then(data => {
                this.$notify({
                  message: JSON.parse(data.message).message,
                  type: 'danger'
                })
              })
            )
            .finally(() => {
              this.serversLoading = false
            })
        }
      })
    },
    openDialogRestart(server_id = undefined) {
      let server_ids = []
      if (server_id !== undefined) {
        server_ids.push(server_id)
      } else {
        server_ids = this.selected
      }
      let indexSet = new Set(server_ids)
      const servers = this.servers
        .filter(value => {
          return indexSet.has(value.server_id)
        })
        .map(d => {
          return d['name']
        })
      const msg = servers
        .map(d => {
          return d
        })
        .join(', ')
      this.$dialog.confirm({
        message: `${this.$t('confirm.restart', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.servers = this.servers.map(value => {
            if (indexSet.has(value.server_id)) {
              value.status = 'processing'
            }
            return value
          })
          this.restartServers(server_ids)
            .then(res => {
              if (!res.ok) {
                throw res.json()
              }
              return res.json()
            })
            .then(() => {
              this.notifyServer({
                name: msg,
                status: 'running'
              })
            })
            .catch(error =>
              error.then(data => {
                this.$notify({
                  message: JSON.parse(data.message).message,
                  type: 'danger'
                })
              })
            )
            .finally(() => {
              this.serversLoading = false
            })
        }
      })
    },
    restartServers(server_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/servers/restart`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_ids: server_ids
        }),
        method: 'POST'
      })
    },
    removeServers(server_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/servers/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_ids: server_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          const indexSet = new Set(server_ids)
          this.servers = this.servers.filter(value => {
            return !indexSet.has(value.server_id)
          })
          this.selected = []
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    runServers(server_id = undefined) {
      if (!this.selected.length && server_id === undefined) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }

      let server_ids = []
      if (server_id !== undefined) {
        server_ids.push(server_id)
      } else {
        server_ids = this.selected
      }
      let indexSet = new Set(server_ids)
      const servers = this.servers
        .filter(value => {
          return indexSet.has(value.server_id)
        })
        .map(d => {
          return d['name']
        })
      const msg = servers
        .map(d => {
          return d
        })
        .join(', ')

      this.servers = this.servers.map(value => {
        if (indexSet.has(value.server_id)) {
          value.status = 'processing'
        }
        return value
      })
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/servers/start`
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_ids: server_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.notifyServer({
            name: msg,
            status: 'running'
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    stopServers(server_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/servers/stop`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_ids: server_ids
        }),
        method: 'POST'
      })
    },
    notifyServer(variables) {
      this.$notify({
        message: `${this.$t('notification.serverWas', {
          server: variables.name,
          status: this.$t(`notification.server.${variables.status}`)
        })}.`,
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss">
.table-layout .b-table {
  .table {
    width: 100%;
    td.runstop {
      width: 6rem;
    }
    .button {
      &.play {
        border: 0;
        padding: 0;
        margin-left: 0.5rem;
        height: max-content;
        color: #4bbd4d;
        background-color: #fff;
      }
      &.stop {
        border: 0;
        padding: 0;
        margin-left: 0.5rem;
        height: max-content;
        color: #fc4850;
        background-color: #fff;
      }
      &.reload {
        border: 0;
        padding: 0;
        margin-left: 0.5rem;
        height: max-content;
      }
    }
  }
}
</style>
